import { injectGlobal } from '@emotion/css';

import { inlineTextLinkStyle } from '../components/links';

injectGlobal({
  'p a': inlineTextLinkStyle,
});
